var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-address-wrapper"},[_c('button',{staticClass:"primary-button new-address-button"},[_c('font-awesome-icon',{attrs:{"icon":"plus"}}),_vm._v(" New Address")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }